export function stickyButtonHandler() {
  const stickyButton = document.querySelector('.sticky-button');
  const phoneInput = document.querySelector('.create-quote-form input[type="tel"]');
  const getQuoteButtons = document.querySelectorAll('.under-banner .get-quote-btn');

  // show/hide on scroll
  window.addEventListener('scroll', () => {
    if (window.scrollY > 300) {
      stickyButton.classList.add('show');
    } else {
      stickyButton.classList.remove('show');
    }
  });

  stickyButton.addEventListener('click', () => {
   window.scrollTo({
     top: 0,
     behavior: 'smooth'
   });
   setTimeout(() => {
     phoneInput.focus();
   }, 400);
  });

  // 
  getQuoteButtons.forEach(btn => {
    btn.addEventListener('click', event => {
      setTimeout(() => {
        phoneInput.focus();
      }, 400);
    });
  });
}